import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import '../styles/fonts.css';

const faqs = [
  {
    question: 'Who Qualifies for the Restorative Connections Program',
    answer: 'Our programs are designed for older adults who are looking to maintain or improve their physical mobility, cognitive health, and social engagement. We welcome individuals who may be recovering from an injury, managing a chronic condition, or simply aiming for a more active lifestyle. Eligibility depends on a brief initial assessment. Our experienced restorative team will guide you at your own pace and will ensure that you feel comfortable throughout your restorative therapy journey.',
  },
  {
    question: 'How to start my Restorative journey?',
    answer: 'Getting started is easy! Simply fill out our contact form or call us to schedule a free phone consultation.',
  },
  {
    question: 'Insurance coverage?',
    answer: 'Coverage details vary widely, so we encourage you to contact our administrative team with your insurance information, and we will happily verify your benefits and coverage options before starting any program.',
  },
  {
    question: 'Frequency of sessions?',
    answer: "Session frequency and duration depend on client tolerance and needs to maximize exercise benefits.  Individual should participate for a minimum of one hour, 3 times a week. We will establish a schedule that works best for you and your family. ",
  },
  // {
  //   question: 'Do you offer virtual or online sessions?',
  //   answer: 'Absolutely! We understand the importance of flexibility. Many of our classes and consultations are available online, allowing you to participate from the comfort of your home while still receiving personalized guidance.',
  // },
];

export default function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    // <section id="faq" className="py-40 bg-gradient-to-b from-gray-50 to-white">
    <section id="faq" className="py-24 bg-slate-90">
    
      <div className="max-w-3xl mx-auto px-6">
        <motion.div
          className="text-center mb-10"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-emerald-600 font-medium text-sm uppercase tracking-wider">FAQ</span>
          <h2 className="text-4xl md:text-5xl kaushan-script font-bold text-gray-900 mt-3 mb-6">
            Frequently Asked <span className="text-emerald-600">Questions</span>
          </h2>
          <p className="text-gray-600 fuzzy-bubbles text-med">
            Find answers to common questions about our restorative connections programs and services.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-purple-200 transition-colors"
              >
                <span className="font-semibold varela-round-400 text-gray-900 pr-8">{faq.question}</span>
                <motion.div
                  className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
                    openIndex === index 
                      ? 'bg-gradient-to-r from-emerald-500 to-teal-500' 
                      : 'bg-gray-100'
                  }`}
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <AnimatePresence mode="wait">
                    {openIndex === index ? (
                      <motion.div
                        key="minus"
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                      >
                        <Minus className="w-5 h-5 text-white" />
                      </motion.div>
                    ) : (
                      <motion.div
                        key="plus"
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                      >
                        <Plus className="w-5 h-5 text-gray-600" />
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                  >
                    <div className="px-6 pb-6">
                      <div className="pt-2 border-t border-gray-100">
                        <p className="text-gray-600 leading-relaxed pt-4">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}